import React, { useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

export default function ShowcaseCriticReviewCard({ review }) {
  const [showMore, setShowMore] = useState(true);

  const cardMessageRef = useRef();

  const messageHeight = cardMessageRef?.current?.scrollHeight;

  useEffect(() => {
    if (messageHeight < 120) {
      setShowMore(false);
    }
  }, [messageHeight]);


  return (
    <article key={review.outletName} className={classNames('ShowcaseCriticReviewCard', { 'ShowcaseCriticReviewCard--expanded': !showMore })}>
      <div className="ShowcaseCriticReviewCard__scoreReviewer">
        <div className="ShowcaseCriticReviewCard__scoreReviewer__score">
          {review.displayScore}
        </div>
        <div className="ShowcaseCriticReviewCard__scoreReviewer__reviewer">
          {review.outletName}
        </div>
      </div>

      <div className="ShowcaseCriticReviewCard__review">
        <div className="ShowcaseCriticReviewCard__review__message" ref={cardMessageRef}>
          {review.message}
          {showMore &&
            <div className="ShowcaseCriticReviewCard__review__gradient" />
          }
        </div>
        {showMore &&
          <button className="ShowcaseCriticReviewCard__review__button" onClick={() => { setShowMore(false); }}>
            <FormattedMessage id="showcaseCriticReviewCard.button.more" defaultMessage="Show more" />
          </button>
        }
      </div>
    </article>
  );
}
